export const ALL_ELD_SM = "ALL_ELD_SM";
export const ELD_SM_TEST = "ELD_SM_TEST";
export const ELD_SM_DRIVERS = "ELD_SM_DRIVERS";
export const ELD_SM_VEHICLES = "ELD_SM_VEHICLES";
